
export default {
    name: 'IconPriceCatalog',
    props: {
        width: {
            type: String,
            default: '20px'
        },
        height: {
            type: String,
            default: '20px'
        },
        color: {
            type: String,
            default: '#303030'
        }
    }
}
